import React from 'react'
import { css } from '@emotion/css'
import { LicensedOnlyCheckbox } from '../licensed-only-checkbox'
import { GroupBySinkCheckbox } from '../group-by-sink-checkbox'
import { RouteContextValue } from '../../../components/route-provider/index'

export interface HeaderCheckboxesProps {
  showLicensedOnlyCheckbox: boolean
  licensedOnly: boolean
  showGroupBySink: boolean
  isGroupBySinkEnabled: boolean
  isSinkDrilldown: boolean
  toggleQueryParameters: RouteContextValue['toggleQueryParameters']
}

export function HeaderCheckboxes({
  showLicensedOnlyCheckbox,
  licensedOnly,
  showGroupBySink,
  isGroupBySinkEnabled,
  isSinkDrilldown,
  toggleQueryParameters
}: HeaderCheckboxesProps) {
  function toggleGroupBySink() {
    toggleQueryParameters('vulns', new Map([['groupedBy', 'SINK']]))
  }

  function toggleLicensedOnly() {
    toggleQueryParameters('vulns', new Map([['licensedOnly', 'true']]))
  }

  function toggleBothCheckboxes() {
    toggleQueryParameters(
      'vulns',
      new Map([
        ['groupedBy', 'SINK'],
        ['licensedOnly', 'true']
      ])
    )
  }

  if (isSinkDrilldown) {
    return null
  }

  return (
    <div className={css('display: flex')}>
      {showGroupBySink && (
        <div className={css('margin-right: 15px;')}>
          <GroupBySinkCheckbox
            toggleBothCheckboxes={toggleBothCheckboxes}
            isGroupBySinkEnabled={isGroupBySinkEnabled}
            toggleGroupBySink={toggleGroupBySink}
            licensedOnly={licensedOnly}
          />
        </div>
      )}
      {showLicensedOnlyCheckbox && (
        <LicensedOnlyCheckbox
          isGroupBySinkEnabled={isGroupBySinkEnabled}
          licensedOnly={licensedOnly}
          toggleLicensedOnly={toggleLicensedOnly}
        />
      )}
    </div>
  )
}
